<template>
  <b-modal
    id="modalCreateCalculationProductionPosts"
    v-model="localActive"
    title="Показывать в таблице должности"
    centered
    hide-footer
    hide-header
    @close="localActive = false"
  >
    <div class="m-posts">
      <svg
        class="m-posts-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-posts-title">Показывать в таблице должности:</div>
      <div class="m-posts-search">
        <c-input
          v-model="search"
          class="m-posts-search-input"
          placeholder="Поиск по должностям"
          icon="search"
          placeholder-style="italic"
          clearable
        />
      </div>

      <div class="position-relative">
        <div id="m-posts-content-shadow-top" class="m-posts-content-shadow-top"></div>
        <div id="m-posts-content" class="m-posts-content" @scroll="setShadowsOnScroll">
          <div class="m-posts-content-result">
            <template v-for="post in postsLocal">
              <c-switcher
                v-if="post.isVisible"
                :key="post.name"
                v-model="post.isActive"
                class="m-posts-content-result-item"
                type="checkbox"
                :label="post.name"
              />
            </template>
          </div>
          <div v-if="!postsLocal.some((post) => post.isVisible)" class="m-posts-content-empty">
            Должности не найдены
          </div>
        </div>
        <div id="m-posts-content-shadow-bottom" class="m-posts-content-shadow-bottom"></div>
      </div>

      <div class="m-posts-actions">
        <c-button size="large" class="m-posts-actions-reset" label="Сбросить" @click="reset()" />
        <c-button class="m-posts-actions-apply" label="Применить" color="blue" size="large" @click="submitPosts()" />
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from "@/components/controls/input";
import Button from "@/components/controls/button";
import Switcher from "@/components/controls/switcher";

export default {
  name: "m-create-calculations-posts",

  components: {
    "c-input": Input,
    "c-button": Button,
    "c-switcher": Switcher,
  },

  props: ["active", "posts", "tableRecords"],

  data() {
    return {
      localActive: false,
      postsLocal: [],
      postsStatesLocal: [],
      search: "",
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        setTimeout(() => {
          this.search = "";
          this.postsLocal = JSON.parse(JSON.stringify(this.postsStatesLocal));
        }, 150);
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
    posts(value) {
      const posts = value.map((post) => {
        let postIsActive = false;
        const c = this.tableRecords.findIndex((groupPost) => groupPost.code === post.code);
        if (c !== -1) {
          postIsActive = true;
        }
        return {
          code: post.code,
          name: post.name,
          isActive: postIsActive,
          isVisible: true,
        };
      });

      posts.sort((a, b) => a.name.localeCompare(b.name));

      // console.log(value)
      this.postsLocal = JSON.parse(JSON.stringify(posts));
      this.postsStatesLocal = JSON.parse(JSON.stringify(posts));

      this.submitPosts();
    },
    search(value) {
      if (value.length > 0) {
        this.postsLocal.forEach((post) => {
          if (post.name.toLowerCase().includes(value.toLowerCase())) {
            post.isVisible = true;
          } else {
            post.isVisible = false;
          }
        });
      } else {
        this.postsLocal.forEach((post) => {
          post.isVisible = true;
        });
      }
      setTimeout(() => {
        this.setShadowsOnScroll();
      }, 100);
    },
  },

  mounted() {
    setTimeout(() => {
      this.setShadowsOnScroll();
    }, 500);
  },

  methods: {
    handleScroll(e) {
      this.scrolled = e.target.scrollTop > 0;
    },
    reset() {
      setTimeout(() => {
        this.search = "";
        this.postsLocal = JSON.parse(JSON.stringify(this.postsStatesLocal));
      }, 150);
      this.localActive = false;
    },
    submitPosts() {
      this.postsStatesLocal = JSON.parse(JSON.stringify(this.postsLocal));
      this.$emit("submitPosts", this.postsLocal);
      this.localActive = false;
    },
    setShadowsOnScroll() {
      const shadowBottomElement = document.getElementById("m-posts-content-shadow-bottom");
      const shadowTopElement = document.getElementById("m-posts-content-shadow-top");
      const scrollElement = document.getElementById("m-posts-content");
      if (scrollElement !== null) {
        // if container scrollable
        if (scrollElement.scrollHeight > scrollElement.clientHeight) {
          // top shadow handler
          if (scrollElement.scrollTop !== 0) {
            shadowTopElement.classList.add("m-posts-content-shadow-top-active");
          } else if (scrollElement.scrollTop === 0) {
            shadowTopElement.classList.remove("m-posts-content-shadow-top-active");
          }
          // bottom shadow handler
          if (scrollElement.scrollTop + scrollElement.clientHeight !== scrollElement.scrollHeight) {
            shadowBottomElement.classList.add("m-posts-content-shadow-bottom-active");
          } else {
            shadowBottomElement.classList.remove("m-posts-content-shadow-bottom-active");
          }
        } else {
          shadowTopElement.classList.remove("m-posts-content-shadow-top-active");
          shadowBottomElement.classList.remove("m-posts-content-shadow-bottom-active");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-posts {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 14px;
    right: 12px;
  }

  &-search {
    margin-top: 26px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
  }

  &-content {
    margin-top: 27px;
    overflow-y: auto;
    position: relative;
    max-height: 397px;

    &-shadow-top {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: transparent;
      opacity: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;

      &-active {
        background: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(16.13%, rgba(255, 255, 255, 0)),
          color-stop(100%, #ffffff)
        );
        opacity: 1;
      }
    }

    &-shadow-bottom {
      position: absolute;
      background: transparent;
      bottom: 0;
      left: 0;
      pointer-events: none;
      height: 30px;
      width: 100%;
      opacity: 0;
      transition: 0.2s;

      &-active {
        opacity: 1;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
      }
    }

    @media screen and (max-width: 700px) {
      max-height: calc(100vh - 200px);
    }

    &::-webkit-scrollbar {
      width: 4px !important;
      height: 4px !important;
      background: white;
      cursor: pointer;
      z-index: 300;
      position: relative;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 10px;
      background-clip: padding-box;
      border: none !important;
    }

    &::-webkit-scrollbar-track {
      background: #dfe4ef;
      width: 4px !important;
      border-radius: 10px;
      z-index: 300;
      position: relative;
    }

    &-result {
      &-item {
        margin-bottom: 19px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &-actions {
    display: flex;
    margin-top: 30px;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
    }

    &-reset {
      background: white;

      @media screen and (max-width: 700px) {
        width: 50%;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          width: 100%;
          border-radius: 0;
        }
      }
    }

    &-apply {
      margin-left: 12px;

      @media screen and (max-width: 700px) {
        width: 50%;
        margin-left: 0;
      }

      ::v-deep & .c-button__wrapper {
        min-height: 38px !important;

        @media screen and (max-width: 700px) {
          justify-content: center;
          border-radius: 0;
          width: 100%;
        }
      }
    }
  }
}
</style>
